import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

import { CaseSegurosComponent } from './case-seguros.component';

import { CabecalhoModule } from '../../components/cabecalho/cabecalho.module';
import { DescricaoModule } from '../../components/descricao/descricao.module';
import { DetalhesModule } from '../../components/detalhes/detalhes.module';
import { ResultadosModule } from '../../components/resultados/resultados.module';

@NgModule({
  declarations: [
    CaseSegurosComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoModule,
    DescricaoModule,
    DetalhesModule,
    ResultadosModule
  ],
  exports: [
    CaseSegurosComponent
  ]
})

export class CaseSegurosModule { }
